// Generate initials from attendee name for avatar fallback
export const getInitials = (name) => {
  if (!name) return 'U'
  return name?.charAt(0).toUpperCase()
}
